export const DEVICE_ID = 'userdeviceId';